import { defineStore } from 'pinia'
import { ref, computed } from 'vue'

export const useUserStore = defineStore('userStore', () => {
  const settings = ref({id: null, user_group_id: null, current_org: {}, timezone: null})
  const permits = ref({})

  const permit = (name) => {
    return permits.value[name] ? true : false
  }

  const isHijacked = computed(() => {
    return settings.value.is_hijacked
  })

  const kohanaUrl = computed(() => {
    return settings.value.kohana_url
  })

  const org = computed(() => {
    return settings.value.current_org
  })

  const userId = computed(() => {
    return settings.value.user_id
  })

  const hasFeature = (key) => {
    return settings.value?.features?.[key] || false;
  }

  const isSpecialAdmin = computed(() => {
    return settings.value.hijacker_id === 2
  })

  const userGroupId = computed(() => {
    return settings.value.user_group_id
  })

  const isAdmin = computed(() => {
    return settings.value.user_group_id === 4
  })

  const isAuthenticated = computed(() => {
    return settings.value.user_id ? true : false
  })

  const useAllNew = computed(() => {
    if (org.value.id > 657) {
      return true
    }

    return [154, 652].includes(org.value.id)
  })

  const useNewAuditEdit = computed(() => {
    if (useAllNew.value) {
      return true
    }

    return hasFeature('l-audits')
  })

  const useNewTemplateBuilder = computed(() => {
    if (useAllNew.value) {
      // return true
    }

    return hasFeature('l-templates')
  })

  const isMyOrg = (orgId) => {
    if (!orgId) {
      return true
    }

    return org.value.id === orgId
  }

  const isThirdParty = computed(() => {
    return settings.value.is_third_party
  })

  const userTimezone = computed(() => {
    return settings.value.timezone || 'UTC'
  })

  const tokenKey = ref('freshability trace track')

  function setTokenAndUser(token, user) {
    if (token) {
      localStorage.setItem(tokenKey.value, token)
      if (window.req && window.req.setUser) {
        window.req.setUser(token)
      } else if (window.axios) {
        window.axios.defaults.headers.common['Authorization'] = 'Bearer ' + token
      }
    }
    if (typeof settings.value !== 'object' || settings.value === null) {
      settings.value = {}
    }
    if (user) {
      settings.value.user_id = user.id
      settings.value.email = user.email
      settings.value.first = user.first
      settings.value.last = user.last
      if (user.organization_id) {
        settings.value.organization_id = user.organization_id
      }
      if (user.current_org) {
        settings.value.current_org = user.current_org
      }
    }
  }

  return { settings, permits, permit, isHijacked, kohanaUrl, org, hasFeature, userId, isMyOrg, isSpecialAdmin, userGroupId, isAdmin, isAuthenticated, useAllNew, tokenKey, isThirdParty, userTimezone, setTokenAndUser, useNewAuditEdit, useNewTemplateBuilder }
})
